<template>
    <div class="score-history__item">
        <div class="column"><div class="write-off">{{item.operationType ? item.operationType.name : 'Списання'}}</div></div>
        <div class="column">{{ item.createdAt }}</div>
        <div class="column">{{ item.userFullName }}</div>
        <div class="column"><div class="write-off-amount">{{ (item.amount * item.transactionMeta.sign).toFixed(2) }}</div></div>
        <div class="column">{{ item.currentAmount }}</div>
        <div class="column"><span>Продукт:</span> {{ item.product ? item.product.title : 'Промокод' }}</div>
        <div class="column"><span>СК:</span> {{ item.company || (item.provider ? item.provider.title : '') }}</div>
        <div class="column"><span>Джерело:</span> {{ item.source }}</div>
        <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>
    </div>
</template>

<script>
export default {
    name: 'RowBlockPromoCodeDiscount',
    props: {
        item: {
            type: Object,
            default: () => {
                return {};
            },
        },
    }
}
</script>
